import styled from 'styled-components';

const SpinnerWrapper = styled.div`
    position: absolute;
    background: transparent;
    left: 50%;
    top: 25%;
    margin-left: -1rem;
    margin-top: 10rem;
`;

export default SpinnerWrapper;
